import SyncWorkerModel from '../../../models/secure/SyncWorkerModel';

/**
 * @param {*} context auto-populated by vuex
 * @param {*} payload {
 *      userEmail - user's email address logged in
 *      sessionId - user's session id
 *      codeName  - worker's name in string
 *      capacity  - worker's reservation of pending jobs - integer
 *      process   - worker's target to process per execution - integer
 *      delay     - amount in milliseconds to use as delay per job sync - long
 *      updatedBy - The email address of the user who attempts to modify worker's record - string
 *      enabled   - determines if the worker should be enabled/disabled - boolean
 * }
 * @returns 
 */
const addNewWorker = async (context, payload) => {
    let syncWorkerModel = new SyncWorkerModel();
    return syncWorkerModel.addNewWorker(payload).then(res => {
        return res.data;
    }).catch(err => {
        return SyncWorkerModel.defaultError(err);
    });
}

/**
 * @param {*} context auto-populated by vuex
 * @param {*} payload {
 *      userEmail - user's email address logged in
 *      sessionId - user's session id
 *      id - worker's id - string
 *      codeName - worker's name - string
 * }
 * @returns 
 */
const retrieveWorker = async (context, payload) => {
    let syncWorkerModel = new SyncWorkerModel();
    return syncWorkerModel.retrieveWorker(payload).then(res => {
        context.commit('SET_WORKER', res.data.records);
        return res.data;
    }).catch(err => {
        return SyncWorkerModel.defaultError(err);
    });
}

/**
 * @param {*} context auto-populated by vuex
 * @param {*} payload {
 *      userEmail - user's email address logged in
 *      sessionId - user's session id
 *      id        - worker's id - string
 *      codeName  - worker's name - string
 *      capacity  - worker's reservation of pending jobs - integer
 *      process   - worker's target to process per execution - integer
 *      delay     - amount in milliseconds to use as delay per job sync - long
 *      updatedBy - The email address of the user who attempts to modify worker's record - string
 *      enabled   - determines if the worker should be enabled/disabled - boolean
 * }
 * @returns 
 */
const updateWorker = async (context, payload) => {
    let syncWorkerModel = new SyncWorkerModel();
    return syncWorkerModel.updateWorker(payload).then(res => {
        return res.data;
    }).catch(err => {
        return SyncWorkerModel.defaultError(err);
    });
}

/**
 * @param {*} context auto-populated by vuex
 * @param {*} payload {
 *      userEmail - user's email address logged in
 *      sessionId - user's session id
 *      id - worker's id - string 
 * }
 * @returns 
 */
const removeWorker = async (context, payload) => {
    let syncWorkerModel = new SyncWorkerModel();
    return syncWorkerModel.removeWorker(payload).then(res => {
        return res.data;
    }).catch(err => {
        return SyncWorkerModel.defaultError(err);
    });
}

/**
 * @param {*} context auto-populated by vuex
 * @param {*} payload { 
 *      userId - string
 *      sessionId - string
 * }
 * @returns 
 */
const getAllWorkers = async (context, payload) => {
    let syncWorkerModel = new SyncWorkerModel();
    return syncWorkerModel.getAllWorkers(payload).then(res => {
        if (res.data && res.data.status == SyncWorkerModel.STATUS_SUCCESS) {
            context.commit('SET_FAILED_JOBS', res.data.records.failedJobs);
            context.commit('SET_PENDING_JOBS', res.data.records.pendingJobs);
            context.commit('SET_SYNC_JOBS', res.data.records.syncJobs);
            context.commit('SET_WORKER_LIST', res.data.records.workers);
        } else {
            context.commit('CLEAR_WORKER_LIST');
        }
        return res.data;
    }).catch(err => {
        return SyncWorkerModel.defaultError(err);
    });
}

/**
 * @param {*} context auto-populated by vuex
 * @param {*} payload { 
 *      userId - string
 *      sessionId - string
 * }
 * @returns 
 */
 const isOperationEnabled = async (context, payload) => {
    let syncWorkerModel = new SyncWorkerModel();
    return syncWorkerModel.operationAllowed(payload).then(res => {
        return res.data;
    }).catch(err => {
        return SyncWorkerModel.defaultError(err);
    });
}

export {
    addNewWorker,
    retrieveWorker,
    updateWorker,
    removeWorker,
    getAllWorkers,
    isOperationEnabled
}
